if (!customElements.get('flowbam-featured-rail')) {
  customElements.define(
    'flowbam-featured-rail',
    class FlowbamFeaturedRail extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('[data-featured-rail]');
        this.controls = this.querySelector('[data-featured-controls]');
        this.previousButton = this.querySelector('[data-featured-previous]');
        this.nextButton = this.querySelector('[data-featured-next]');
        this.filterButtons = [...this.querySelectorAll('[data-featured-filter]')];
        this.status = this.querySelector('[data-featured-status]');
        this.collectionTemplate = this.querySelector('[data-featured-collection-template]');
        this.collectionCards = null;
        this.styleKeys = this.filterButtons.map((button) => button.dataset.featuredFilter).filter(Boolean);
        this.viewAll = this.querySelector('[data-featured-view-all]');

        if (!this.rail) return;

        this.handlePrevious = () => this.move(-1);
        this.handleNext = () => this.move(1);
        this.handleFilter = (event) => this.filter(event.currentTarget.dataset.featuredFilter);
        this.updateControls = this.updateControls.bind(this);

        this.previousButton?.addEventListener('click', this.handlePrevious);
        this.nextButton?.addEventListener('click', this.handleNext);
        this.filterButtons.forEach((button) => button.addEventListener('click', this.handleFilter));
        this.rail.addEventListener('scroll', this.updateControls, { passive: true });
        window.addEventListener('resize', this.updateControls);

        const requested = new URLSearchParams(window.location.search).get('style');
        const DEFAULT_STYLE = 'Calm';
        const initialStyle = requested && this.styleKeys.includes(requested)
          ? requested
          : (this.styleKeys.includes(DEFAULT_STYLE) ? DEFAULT_STYLE : '');
        this.currentStyle = '';
        this.applyStyle(initialStyle, { updateUrl: false });
        window.requestAnimationFrame(this.updateControls);
      }

      disconnectedCallback() {
        if (!this.rail) return;

        this.previousButton?.removeEventListener('click', this.handlePrevious);
        this.nextButton?.removeEventListener('click', this.handleNext);
        this.filterButtons?.forEach((button) => button.removeEventListener('click', this.handleFilter));
        this.rail.removeEventListener('scroll', this.updateControls);
        window.removeEventListener('resize', this.updateControls);
      }

      move(direction) {
        const firstCard = [...this.rail.children].find((item) => !item.hidden);
        if (!firstCard) return;

        const railStyles = window.getComputedStyle(this.rail);
        const gap = Number.parseFloat(railStyles.columnGap || railStyles.gap) || 0;
        const amount = firstCard.getBoundingClientRect().width + gap;

        this.rail.scrollBy({ left: direction * amount, behavior: 'smooth' });
      }

      setViewAll(style) {
        if (!this.viewAll) return;
        const base = this.viewAll.dataset.baseHref || this.viewAll.getAttribute('href').split('?')[0];
        this.viewAll.dataset.baseHref = base;
        this.viewAll.setAttribute('href', style ? `${base}?style=${encodeURIComponent(style)}` : base);
      }

      /** 未选 = 未筛选预览（显示全部）；选中某一 Style = 只显示 data-style 匹配的卡片。 */
      applyStyle(style, options = {}) {
        const { updateUrl = true } = options;
        this.currentStyle = style || '';

        this.rail.querySelectorAll('.flowbam-card').forEach((card) => {
          card.hidden = Boolean(style) && card.dataset.style !== style;
        });

        this.filterButtons.forEach((button) => {
          const isActive = Boolean(style) && button.dataset.featuredFilter === style;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', String(isActive));
        });

        this.setViewAll(style);

        if (this.status) {
          const shown = [...this.rail.querySelectorAll('.flowbam-card')].filter((card) => !card.hidden).length;
          if (style && shown === 0) {
            this.status.hidden = false;
            this.status.textContent = 'No pieces match this style yet. Clear the filter to see everything.';
          } else {
            this.status.hidden = true;
            this.status.textContent = '';
          }
        }

        if (updateUrl && window.history && window.history.replaceState) {
          const nextUrl = new URL(window.location.href);
          if (style) nextUrl.searchParams.set('style', style);
          else nextUrl.searchParams.delete('style');
          window.history.replaceState({}, '', nextUrl);
        }
      }

      filter(style) {
        const next = this.currentStyle === style ? '' : style;
        this.applyStyle(next);
        this.rail.scrollTo({ left: 0, behavior: 'smooth' });
        window.requestAnimationFrame(this.updateControls);
      }

      updateControls() {
        const maxScroll = this.rail.scrollWidth - this.rail.clientWidth;
        const isDesktop = window.matchMedia('(min-width: 990px)').matches;
        const isScrollable = maxScroll > 2;
        const atStart = this.rail.scrollLeft <= 2;
        const atEnd = this.rail.scrollLeft >= maxScroll - 2;
        const visibleCard = [...this.rail.querySelectorAll('.flowbam-card')].find((card) => {
          const item = card.parentElement === this.rail ? card : card.parentElement;
          return item && !item.hidden;
        });
        const media = visibleCard?.querySelector('.flowbam-card__img');
        const railWrap = this.controls?.parentElement;

        if (media && railWrap) {
          const mediaRect = media.getBoundingClientRect();
          const railWrapRect = railWrap.getBoundingClientRect();
          const controlTop = mediaRect.top - railWrapRect.top + mediaRect.height / 2;
          this.controls.style.setProperty('--featured-control-top', `${Math.round(controlTop)}px`);
        }

        if (this.controls) this.controls.hidden = !isDesktop || !isScrollable;
        if (this.previousButton) this.previousButton.disabled = !isScrollable || atStart;
        if (this.nextButton) this.nextButton.disabled = !isScrollable || atEnd;
      }
    }
  );
}
